import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { BaseEntryProductComponent } from '@products/base-entry-product-component';
import { Logger } from '@utils/logger';
import { OverviewComponentConfig } from '../overview-component.config';
import { OverviewDisplayComponent } from '../overview-display-component.interface';

const logger = Logger.getLogger('OverviewEntryComponent');

@Component({
  selector: 'ft-overview-entry',
  templateUrl: './overview-entry.component.html',
  styleUrls: ['./overview-entry.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OverviewEntryComponent
  extends BaseEntryProductComponent
  implements OnInit, OnDestroy {
  @ViewChild('dynamicCmp', { read: ViewContainerRef, static: false }) container;
  componentType: string;
  componentRef: ComponentRef<OverviewDisplayComponent>;
  componentConfig: OverviewComponentConfig;
  isLoading = true;
  errorMsg: string;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private changeDetector: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.componentType = this.brConfig?.componentType;
    this.componentConfig = OverviewComponentConfig.getConfig(
      this.componentType,
      this.configurationName
    );
    this.changeDetector.detectChanges(); // at this point show component if componentType exists

    if (this.componentConfig) {
      const componentFactory = this.componentFactoryResolver.resolveComponentFactory(
        this.componentConfig.component
      );
      this.container.clear();
      this.componentRef = this.container.createComponent(componentFactory);
      this.isLoading = false;
      this.errorMsg = null;

      this.componentRef.instance.populate(
        this.componentConfig,
        this.brConfig,
        this.component,
        this.page
      );
      this.changeDetector.detectChanges(); // to remove loading message
    } else {
      logger.error(
        'No component found: ',
        this.componentType,
        this.configurationName
      );
      this.errorMsg = `No component found: ${this.componentType}, ${this.configurationName}`;
    }
  }

  ngOnDestroy() {
    // clean up dynamic component to avoid memory leaks
    this.componentRef?.destroy();
  }
}
